export enum WorkOrderType
{
    BatteryReplacement = 0,
    BrakeService = 1,
    KeyFobService = 2,
    TyreRepair = 3,
    TyreReplacement = 4,
    WiperBladeReplacement = 5,
    WindscreenRepair = 6,
    VehicleHealthChecks = 7
}

export namespace WorkOrderType
{
    /**
     * Converts the item to a string description
     * @param item 
     * @returns 
     */
    export function toString( item: WorkOrderType ): string | undefined
    {
        switch( parseInt( String( item ) ) )
        {
            case WorkOrderType.TyreRepair: return "Puncture Repair"
            case WorkOrderType.TyreReplacement: return "Tyre Repair"
            case WorkOrderType.BrakeService: return "Brake Component Repair"
            case WorkOrderType.BatteryReplacement: return "Battery Repair"
            case WorkOrderType.WiperBladeReplacement: return "Wiper-blade Repair"
            case WorkOrderType.KeyFobService: return "Key Fob Repair"
            case WorkOrderType.WindscreenRepair: return "Chipped Windscreen Repair"
            case WorkOrderType.VehicleHealthChecks: return "Vehicle Health Check"
            default: return undefined;
        }
    }
}